<template>
    <div id="page">
        <div class="page-content-wrapper" :class="$mq">
            <slot />
        </div>
    </div>
</template>

<script>
    export default {
        name: 'main-page',
    };
</script>

<style lang="scss" scoped>
    #page {
        display: flex;
        flex-direction: column;
        align-items: center;
        min-height: calc(100vh - #{$footer-height});
        min-width: 100vw;

        .page-content-wrapper {
            width: 100%;
            max-width: 1500px;

            .page-content {
                padding: 0 150px;
            }

            &.tablet {
                .page-content {
                    padding: 0 100px;
                }
            }

            &.mobile {
                .page-content {
                    padding: 0 50px;
                }
            }
        }
    }
</style>
